import { RouteProps } from 'react-router-dom';

import { ROUTES } from '@/common';

import ContributionInvoiceReportPage from './ContributionInvoiceReport.page';
import ForfeitureReportPage from './ForfeitureReport.page';
import HealthPlanEnrollmentReportPage from './HealthPlanEnrollmentReport.page';
import ParticipantAccountActivityReportPage from './ParticipantAccountActivityReport.page';
import PlanOmnibusBalanceReportPage from './PlanOmnibusBalanceReport.page';
import PrefundInvoiceReportPage from './PrefundInvoiceReport.page';
import ReplenishmentInvoiceReportPage from './ReplenishmentInvoiceReport.page';
import ScheduledReportsPage from './ScheduledReports.page';
type Route = RouteProps & {
  authed?: boolean;
};

export const GLOBAL_ROUTES: Route[] = [
  {
    path: ROUTES.SCHEDULED_REPORTS,
    component: ScheduledReportsPage,
    authed: true,
  },
  {
    path: ROUTES.FORFEITURE_REPORT,
    component: ForfeitureReportPage,
    authed: true,
  },
  {
    path: ROUTES.HEALTH_PLAN_ENROLLMENTS_REPORT,
    component: HealthPlanEnrollmentReportPage,
    authed: true,
  },
  {
    path: ROUTES.PARTICIPANT_ACTIVITY_REPORT,
    component: ParticipantAccountActivityReportPage,
    authed: true,
  },
  {
    path: ROUTES.CONTRIBUTION_INVOICE_REPORT,
    component: ContributionInvoiceReportPage,
    authed: true,
  },
  {
    path: ROUTES.PREFUND_INVOICE_REPORT,
    component: PrefundInvoiceReportPage,
    authed: true,
  },
  {
    path: ROUTES.REPLENISHMENT_INVOICE_REPORT,
    component: ReplenishmentInvoiceReportPage,
    authed: true,
  },
  {
    path: ROUTES.PLAN_OMNIBUS_BALANCE_REPORT,
    component: PlanOmnibusBalanceReportPage,
    authed: true,
  },
  {
    path: ROUTES.REPLENISHMENT_INVOICE_REPORT,
    component: ReplenishmentInvoiceReportPage,
    authed: true,
  },
];
export default GLOBAL_ROUTES;
